import { decryptor, encryptor } from './utils/decryptor';

declare global {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  interface Window {
    envVariables: IAppVariables;
  }
  // eslint-disable-next-line vars-on-top, no-var
  var envVariables: IAppVariables;
}

interface IAppVariables {
  reactAppGraphqlSocket?: string;
  environment?: string;
  contactFormUrlIframeEn?: string;
  contactFormUrlIframeEs?: string;
  proxyMixpanel?: string;
  mixpanelToken?: string;
  mixpanelStudentToken?: string;
  firebaseProject?: string;
  firebaseApiKey?: string;
  firebaseAuthDomain?: string;
  firebaseStorageBucket?: string;
  firebaseMessagingSenderId?: string;
  firebaseAppId?: string;
  reactAppApiGraphqlDev?: string;
  reactAppGraphqlSocketDev?: string;
  gcpCaptchaWebKey?: string;
  ssoTenantID?: string;
  jwtCharactersSwap?: string;
  qsemEnableAuthSaml?: string;
}

export const initializeVariables = (): void => {
  const variables = globalThis.envVariables;

  if (variables) {
    const jsonString = JSON.stringify(variables);
    const encryptedJson = encryptor(jsonString);

    localStorage.setItem('keys', encryptedJson ?? '');
  }
};

initializeVariables();

const loadVariables = (): IAppVariables | undefined => {
  const storedVariables = decryptor(localStorage.getItem('keys') ?? undefined);
  const envVariables =
    storedVariables && storedVariables.length > 0 ? (JSON.parse(storedVariables ?? '') as IAppVariables) : undefined;

  return {
    reactAppGraphqlSocket: decryptor(envVariables?.reactAppGraphqlSocket) ?? process.env.REACT_APP_GRAPHQL_SOCKET,
    environment: decryptor(envVariables?.environment) ?? 'development',
    contactFormUrlIframeEn: decryptor(envVariables?.contactFormUrlIframeEn) ?? process.env.CONTACT_FORM_URL_IFRAME,
    contactFormUrlIframeEs: decryptor(envVariables?.contactFormUrlIframeEs) ?? process.env.CONTACT_FORM_URL_IFRAME,
    proxyMixpanel: decryptor(envVariables?.proxyMixpanel) ?? process.env.PROXY_MIXPANEL,
    mixpanelToken: decryptor(envVariables?.mixpanelToken) ?? process.env.MIXPANEL_TOKEN,
    mixpanelStudentToken: decryptor(envVariables?.mixpanelStudentToken) ?? process.env.MIXPANEL_STUDENT_TOKEN,
    firebaseProject: decryptor(envVariables?.firebaseProject) ?? process.env.FIREBASE_PROJECT,
    firebaseApiKey: decryptor(envVariables?.firebaseApiKey) ?? process.env.FIREBASE_API_KEY,
    firebaseAuthDomain: decryptor(envVariables?.firebaseAuthDomain) ?? process.env.FIREBASE_AUTH_DOMAIN,
    firebaseStorageBucket: decryptor(envVariables?.firebaseStorageBucket) ?? process.env.FIREBASE_STORAGE_BUCKET,
    firebaseMessagingSenderId:
      decryptor(envVariables?.firebaseMessagingSenderId) ?? process.env.FIREBASE_MESSAGING_SENDER_ID,
    firebaseAppId: decryptor(envVariables?.firebaseAppId) ?? process.env.FIREBASE_APP_ID,
    gcpCaptchaWebKey: decryptor(envVariables?.gcpCaptchaWebKey) ?? process.env.GCP_CAPTCHA_SECRET_KEY,
    reactAppApiGraphqlDev: decryptor(envVariables?.reactAppApiGraphqlDev) ?? process.env.REACT_APP_API_GRAPHQL_DEV,
    reactAppGraphqlSocketDev:
      decryptor(envVariables?.reactAppGraphqlSocketDev) ?? process.env.REACT_APP_GRAPHQL_SOCKET_DEV,
    ssoTenantID: decryptor(envVariables?.ssoTenantID) ?? process.env.SSO_TENANT_ID,
    jwtCharactersSwap: decryptor(envVariables?.jwtCharactersSwap) ?? process.env.JWT_CHARACTERS_SWAP ?? '',
    qsemEnableAuthSaml: decryptor(envVariables?.qsemEnableAuthSaml) ?? 'false',
  };
};

const environmentVariables = loadVariables();

export default environmentVariables;
